<template>
  <div class="g-site">
    <div class="g-site-content">
      <i class="icon iconfont icon-index"></i>
      <span @click="linkTo()">&nbsp;您当前位置：{{site}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "g-nav",
  data() {
    return {
      routerArr: [
        { name: "首页", router: "/home" },
        { name: "产品&企业", router: "/ex-list",children: [
          {name:'展商详情',router:'/ex-details/'},
          {name:'产品详情',router:'/pro-details/'}
        ]},
        { name: "活动集", router: "/act-list", children: [{name:'活动详情',router:'/activity-details/'}]},
        { name: "供需对接", router: "/chance",children:[{name:'供需详情',router:'/chance-detail'}]},
        { name: "CMEF云课", router: "/pro-list" },
        { name: "联系我们", router: "/contact" },
        { name: "品牌展会", router: "/about" },
        { name: "线下论坛", router: "/meeting" },
        { name: "会议直播", router: "/meeting-live" },
      ],
      site: "首页"
    };
  },
  watch: {
    $route(to, from) {
      this.setIndex();
    }
  },
  created() {
    this.setIndex();
  },
  methods: {
    setIndex() {
      this.routerArr.some((el, idx) => {
        const path = this.$router.history.current.path;
        const pathUrl = this.$route.name;
        if (path.search(el.router) !== -1) {
          if (el.name !== "首页") {
            this.site = "首页" + " > " + el.name;
          } else {
            this.site = el.name;
          }
        } 
        if (el.children && el.children.length) {
          el.children.forEach(c => {
            if (path.indexOf(c.router) !== -1) {
              this.site = "首页" + " > " + el.name + " > " + c.name;
            }
          });
        }
        if (pathUrl === "chance-type") {
          this.site = "首页" + " > " + "供需对接" + " > " + this.$route.query.name;
        }
        if (pathUrl === "about") {
          this.site = "首页" + " > " + "品牌展会" + " > " + this.$route.query.name;
        }
        if (pathUrl === "news") {
          if (this.$route.query.type === "0") {
            this.site = "首页" + " > " + "CMEF头条" + " > " + "行业动态";
          }
          if (this.$route.query.type === "1") {
            this.site = "首页" + " > " + "CMEF头条" + " > " + "企业动态";
          }
        }
        if (pathUrl === "news-details") {
          this.site = "首页" + " > " + "CMEF头条" + " > " + "详情";
        }
        if (pathUrl === "meeting") {
          this.site = "首页" + " > " + "学术交流" + " > " +"线下会议";
        }
      });
    },
    linkTo() {
      this.$router.push("/home");
    }
  }
};
</script>

<style lang="scss" scoped>
.g-site {
  width: 100%;
  font-size: 14px;
  &-content {
    width: 1200px;
    line-height: 1;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    align-items: center;
    i {
      font-size: 20px;
      color: #db2a4b;
    }
    span {
      cursor: pointer;
    }
  }
}
</style>
